import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import PropTypes from "prop-types";
import styles from "./Inventory.module.css"; // Adjust path as needed

const ExcelReadTable = ({ validatedData, excelColumns, fileExtension }) => {
  const [displayedData, setDisplayedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const tableContainerRef = useRef(null);

  // Function to load more data
  const loadMoreData = () => {
    if (!loading && hasMore) {
      setLoading(true);
      // Simulate fetching more data
      setTimeout(() => {
        const newData = validatedData.slice(
          displayedData.length,
          displayedData.length + 5
        );
        setDisplayedData((prevData) => [...prevData, ...newData]);
        setLoading(false);
        // Check if there is more data to load
        if (displayedData.length + newData.length >= validatedData.length) {
          setHasMore(false);
        }
      }, 1000); // Simulate network delay
    }
  };

  useEffect(() => {
    setDisplayedData(validatedData.slice(0, 5)); // Initialize with first 5 rows
  }, [validatedData]);

  useEffect(() => {
    const handleScroll = () => {
      const container = tableContainerRef.current;
      if (container) {
        if (
          container.scrollTop + container.clientHeight >=
          container.scrollHeight
        ) {
          loadMoreData();
        }
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [displayedData, loading, hasMore]);

  return (
    <>
      {validatedData.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            {`${fileExtension?.name} File Data`}
          </Typography>
          <TableContainer
            component={Paper}
            sx={{ maxHeight: 400, overflow: "auto" }}
            ref={tableContainerRef}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={styles.readExcelCell}>S.No</TableCell>
                  {excelColumns.map((column) => (
                    <TableCell
                      key={column.key}
                      className={styles.readExcelCell}
                      sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                    >
                      {column.label !== "ERROR" && column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedData.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      // "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                      backgroundColor: row["error"] ? "#fdd" : "transparent", // Optional: color based on error
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    {excelColumns.map((column) => (
                      <TableCell key={column.key}>
                        {column.key !== "error" && (
                          <Typography
                            color={
                              column.key === "message" && row["error"]
                                ? "error"
                                : "textPrimary"
                            }
                          >
                            {row[column.key] || "N/A"}
                          </Typography>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                {loading && (
                  <TableRow>
                    <TableCell colSpan={excelColumns.length + 1} align="center">
                      Loading more data...
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </>
  );
};

ExcelReadTable.propTypes = {
  validatedData: PropTypes.arrayOf(PropTypes.object).isRequired,
  excelColumns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ExcelReadTable;
